/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Col, Container, Row, Tooltip, Typography,
} from '@airbus/components-react';
import { Info } from '@airbus/icons/react';
import ChipLabel from '../../Shared/ChipLabel/ChipLabel';
import { chipConstants } from '../../Shared/ChipLabel/constants';
import './TooltipInfo.scss';
import { FIN, FIN_ACCESS_PANEL } from '../../../utils/constants';
import { useAppSelector } from '../../../store/hooksTypes';

export const chipInfo = (chipArrayType: any, featureToggle?: boolean) => {
  const chipDetails: any = [];
  Object.values(chipConstants).forEach((item: any) => {
    let chipTextArray: string[] = [];
    if (item.chipText) {
      chipTextArray = Array.isArray(item.chipText) ? item.chipText : [item.chipText];
    }
    // remove "Not Checked" so other texts remain visible
    const filteredNc = chipTextArray.filter((text: string) => text !== 'Not Checked');
    if (chipDetails.length === 0 && chipArrayType.includes(item.label)) {
      chipDetails.push(
        <Typography variant="small" className="chip-fin-text">
          This column indicates:
          <br />
          The Checker results for the given configuration:
        </Typography>,
      );
    }
    if (chipArrayType.includes(item.label) || chipArrayType.includes(item.chipIcon)) {
      chipDetails.push(
        <Row>
          <Col xxs={chipArrayType.includes(item.label) ? 2 : 3} className={chipArrayType.includes(item.label) ? 'chip-fin-col' : 'chip-col'}>
            <ChipLabel sourceOfChip={item.chipIcon ? [item.chipIcon] : [item.label]} />
          </Col>
          <Col>
            <Typography variant="small" className="chip-text">{ featureToggle ? item.chipText : filteredNc}</Typography>
          </Col>

        </Row>,
      );
    }
    if ((chipArrayType.includes(item.label) || chipArrayType.includes(item.chipIcon))
      && chipTextArray.includes('Not Checked')) {
      chipDetails.push(
        <Typography variant="small" className="chip-fin-text">
          The FIN - ACCESS/PANEL reference or &quot;No FIN&quot;
          <br />
          <br />
          &quot;No FIN&quot; means either FIN or ACCESS/PANEL
          <br />
          reference:
          <br />
          <li className="chip-fin-list">is NOT expected for the given part number,</li>
          <li className="chip-fin-list">
            is expected for the given part number but it is
            <br />
            NOT (or incorrectly) provided in the data source
          </li>
        </Typography>,
      );
    }
  });
  return chipDetails;
};

export interface TooltipInfoProps {
  showFinStatus: boolean;
  showSourceStatus: boolean;
}

export const TooltipInfo: React.FC<TooltipInfoProps> = ({ showFinStatus, showSourceStatus }) => {
  const featureToggleConfig = useAppSelector((state) => state.featureToggleDetails?.data);
  const featureToggleAccessPanel = featureToggleConfig?.access_panel === 'true';
  const featureToggle = featureToggleConfig?.airnavx_no_fin === 'true';
  const chipIconArray = ['Mismatch', 'Match', 'NA', 'Not Checked'];
  const chipLabelArray = ['W', 'A', 'M', 'NC'];
  return (
    <Container className="tooltip-container">
      <Row>
        {showFinStatus && (
        <Col xxs={4}>
          <Typography variant="small">
            {featureToggleAccessPanel ? FIN_ACCESS_PANEL : FIN}
          </Typography>
        </Col>
        )}
        {showSourceStatus && (
        <Col xxs={4}>
          <Typography variant="small">Source Status</Typography>
        </Col>
        )}
        <Col xxs={6} className="tooltip-col">
          <Tooltip
            placement="bottom"
            label={showFinStatus ? chipInfo(chipLabelArray, featureToggle) : chipInfo(chipIconArray, featureToggle)}
            className={showFinStatus ? 'tooltip-status-info' : 'tooltip-source-info'}
            data-testid="tooltip-info"
          >
            <Info data-testid="info-fin-icon" className={showFinStatus ? 'fin-info' : 'source-info'} />
          </Tooltip>
        </Col>
      </Row>
    </Container>
  );
};
